// topoEditor/render.js — pure: ordered segments -> display HTML.
//
// Text segments are HTML-escaped (dynamic content never becomes markup — no injection). Entity segments
// delegate to their entity's renderHtml(data, idx). idx is a per-kind running index so edit interactions
// (e.g. the link hover-editor) can address the n-th entity of a kind.

export function escapeHtml(s) {
    return String(s).replace(/[&<>]/g, (c) => (c === "&" ? "&amp;" : c === "<" ? "&lt;" : "&gt;"));
}

export function renderSegments(segments, entities, placeholder) {
    const hasContent = segments.some((s) => s.type === "entity" || (s.text && s.text.trim() !== ""));
    if (!hasContent) {
        return '<span class="topo2-editor-placeholder">' + escapeHtml(placeholder || "") + "</span>";
    }
    const byKind = new Map(entities.map((e) => [e.kind, e]));
    const counters = {};
    return segments.map((seg) => {
        if (seg.type === "text") { return escapeHtml(seg.text).replace(/\n/g, "<br>"); }
        const entity = byKind.get(seg.kind);
        const idx = (counters[seg.kind] = (counters[seg.kind] ?? -1) + 1);
        return entity ? entity.renderHtml(seg.data, idx) : escapeHtml(seg.raw);
    }).join("");
}
